import cn from 'classnames'

interface Props {
    tokenLogo?: string
    networkIcon?: string
    className?: string
    tokenIconSize?: number
    chainIconSize?: number
}

const ChainToken: React.FC<Props> = ({
    tokenLogo,
    networkIcon,
    className,
    tokenIconSize = 40,
    chainIconSize = 16,
}: Props) => {
    return (
        <div className={cn('relative flex w-fit items-end', className)}>
            <img
                src={tokenLogo}
                className={`rounded-full`}
                style={{
                    width: `${tokenIconSize}px`,
                    height: `${tokenIconSize}px`,
                    objectFit: 'cover',
                    aspectRatio: '1 / 1',
                    minWidth: `${tokenIconSize}px`,
                    maxWidth: `${tokenIconSize}px`,
                }}
                onError={e => {
                    e.currentTarget.src = '/assets/token/unknown.png'
                }}
            />
            {networkIcon && (
                <img
                    src={networkIcon}
                    className={`absolute right-0 rounded-full`}
                    style={{
                        width: `${chainIconSize}px`,
                        height: `${chainIconSize}px`,
                        minWidth: `${chainIconSize}px`,
                        maxWidth: `${chainIconSize}px`,
                    }}
                />
            )}
        </div>
    )
}

export default ChainToken
